import React, {Component} from 'react';

import strings from '../../strings';

import {de_numbers_trial, de_child_numbers_trial} from './assets';
import listen from '../../assets/listen.png';

import './styles.scss';

class Trial extends Component {
	constructor(props) {
		super(props);

		switch (strings.getLanguage()) {
			case 'nn':
				this.assets = de_numbers_trial;
				break;
			case 'se':
				this.assets = de_numbers_trial;
				break;
			case 'de':
				switch (this.props.testKeyType) {
					case 'child-followup':
						this.assets = de_child_numbers_trial;
						this.wsn_test1 = strings.wsn_test1Child;
						break;
					case 'adult-followup':
						this.assets = de_numbers_trial;
						this.wsn_test1 = '';
						break;
					default:
						this.assets = de_numbers_trial;
						this.wsn_test1 = strings.wsn_test1;
				}
				break;
			case 'no':
			default:
				this.assets = de_numbers_trial;
				break;
		}
	}

	componentWillReceiveProps(newProps) {
		if (newProps.currentStep !== this.props.currentStep) {
			this.startNewTask(newProps.currentStep);
		}
	}

	componentDidMount() {
		if (this.button) this.button.click();
		this.initializeAudio();
	}
	componentWillUnmount() {
		this.stopSounds();
		clearTimeout(this.timeout);
	}

	initializeAudio = () => {
		Object.values(this.assets).forEach((audioEl) => audioEl.load());

		this.timeout = setTimeout(
			() => this.startNewTask(this.props.currentStep),
			1000
		);
	};

	startNewTask = (taskNumber) => {
		this.stopSounds();
		this.playNumbers(taskNumber);
	};

	playNumbers = (sound) => {
		this.assets[sound].play();
	};

	stopSounds = () => {
		for (const sound of Object.values(this.assets)) {
			sound.pause();
		}
	};

	render() {
		return (
			<div className="WorkingMemory">
				<img className="listen-image" src={listen} alt="" />
				<p>{this.wsn_test1}</p>
			</div>
		);
	}
}

export default Trial;
